import { render, staticRenderFns } from "./TeacherBio.vue?vue&type=template&id=30d4ffea&"
import script from "./TeacherBio.vue?vue&type=script&lang=js&"
export * from "./TeacherBio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports